import Dialog from '../UI/Dialog/Dialog'
import { SparklesIcon } from '../UI/Icons'

interface Props {
  isOpen: boolean
  onClose: () => void
}

const HowItWorksDialog = ({ isOpen, onClose }: Props) => (
  <Dialog isModal isOpen={isOpen} onClose={onClose} className='rounded-xl max-w-md w-full mx-4'>
    <div className='p-6 flex flex-col gap-4'>
      <div className='flex items-center justify-between'>
        <div className='flex items-center gap-2 text-[#af231c]'>
          <SparklesIcon />
          <span className='font-bold text-base'>ConciergeAI</span>
        </div>
        <button
          type='button'
          onClick={onClose}
          className='text-[#595959] hover:text-black cursor-pointer leading-none text-xl font-light'
          aria-label='Close'>
          ✕
        </button>
      </div>

      <p className='text-sm text-black leading-6'>
        Before our Meetings Events team dives into the heavy lifting, let{' '}
        <strong>ConciergeAI</strong> give you a sneak peek of some venues that meet your event
        needs. By analysing your event details, it generates immediate venue recommendations to help
        you visualise your event.
      </p>

      <ul className='flex flex-col gap-3 text-sm text-black'>
        <li>
          <strong>Explore Early:</strong> Get immediate, personalised venue inspiration.
        </li>
        <li>
          <strong>Stay in Control:</strong> It&apos;s completely optional, browse the suggestions or
          skip ahead.
        </li>
        <li>
          <strong>Perfect Alignment:</strong> Use your favourite picks to guide our M&E Experts on
          exactly what you&apos;re looking for, let us know any of your preferred spaces or vibes
          you&apos;re after!
        </li>
      </ul>
    </div>
  </Dialog>
)

export default HowItWorksDialog
